import React from "react";
import "../../../pages/Surveys/style.css";
import cogoToast from "cogo-toast";
import "survey-core/defaultV2.min.css";
import "survey-creator-core/survey-creator-core.min.css";
import { Label, Input, Button, Badge } from "reactstrap";
import { useState, useEffect, useMemo } from "react";
import { ListEmployeeApi } from "../../../services/Api";
 
import { FaTimes, FaEdit, FaFileExport, FaArrowRight, FaSearch, FaSort, FaSortUp, FaSortDown } from "react-icons/fa";
import { useHistory } from "react-router-dom";
import { PulseLoader } from "react-spinners";

import {
  Modal,
  ModalHeader,
  ModalBody,
} from 'reactstrap';

import { ENDPOINTS, LOCAL_PATHS, SUCCESS_RESULT } from "../../../Constants";

const LeaveBalances = (props) => {
  const history = useHistory();
  const [is_processing, setProcessing] = useState(false);
  const { data } = (props.location && props.location.state) || {};
  const [rowData, setRowData] = useState([]);

  const [selected_staff, setSelected_staff] = useState(null)
  const [showModal, setshowModal] = useState(false)

  const toggle = () => setshowModal(!showModal);

  // Table search and pagination state
  const [tableSearch, setTableSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(20);
  const [sortField, setSortField] = useState("");
  const [sortDirection, setSortDirection] = useState("asc");

  useEffect(() => {
    fetch_data();
    return () => {};
  }, []);

  const fetch_data = () => {
    setProcessing(true);

    ListEmployeeApi()
      .then((res) => {
        setProcessing(false);
        if (res.status == 200) {
          var response = res.data;
          console.log(JSON.stringify(res.data));
          if (response.status == SUCCESS_RESULT) {
            let _data = [];
            if (response.data?.length < 1) {
              alert("No Record ");
              return;
            }

            setRowData(response.data);
          } else {
            cogoToast.error(res.data.message, {
              hideAfter: 5,
            });
          }
        } else {
          cogoToast.error(res.message, {
            hideAfter: 5,
          });
        }
      })
      .catch((err) => {
        setProcessing(false);
        console.log(err);
        cogoToast.error(err, {
          hideAfter: 5,
        });

        cogoToast.error("Something went wrong, please Try again.", {
          hideAfter: 5,
        });
      });
  };

  // Filter data based on search term - searches all columns
  const filteredData = useMemo(() => {
    let data = rowData;
    
    // Apply search filter - search across all columns
    if (tableSearch) {
      const searchLower = tableSearch.toLowerCase();
      data = data.filter(item => {
        // Search in all relevant fields
        const staffId = String(item?.staff_id || "").toLowerCase();
        const staffName = item?.staff_name?.toLowerCase() || "";
        const email = item?.email?.toLowerCase() || "";
        const telephone = item?.telephone?.toLowerCase() || "";
        const roleName = item?.role_name?.toLowerCase() || "";
        const officeName = item?.office_name?.toLowerCase() || "";
        const contractStartDate = item?.contract_start_date?.toLowerCase() || "";
        const contractEndDate = item?.contract_end_date?.toLowerCase() || "";
        const annualLeave = item?.leave_data?.find(l => l.name?.includes("Annual"))?.remaining_days?.toString() || "";
        
        return staffId.includes(searchLower) ||
               staffName.includes(searchLower) ||
               email.includes(searchLower) ||
               telephone.includes(searchLower) ||
               roleName.includes(searchLower) ||
               officeName.includes(searchLower) ||
               contractStartDate.includes(searchLower) ||
               contractEndDate.includes(searchLower) ||
               annualLeave.includes(searchLower);
      });
    }
    
    // Apply sorting
    if (sortField) {
      data = [...data].sort((a, b) => {
        let aValue, bValue;
        
        if (sortField === 'annual_leave') {
          const aLeave = a?.leave_data?.find(l => l.name?.includes("Annual"));
          const bLeave = b?.leave_data?.find(l => l.name?.includes("Annual"));
          aValue = aLeave?.remaining_days || 0;
          bValue = bLeave?.remaining_days || 0;
          return sortDirection === "asc" ? aValue - bValue : bValue - aValue;
        } else {
          aValue = a[sortField] || "";
          bValue = b[sortField] || "";
        }
        
        // Handle null/undefined values
        if (aValue == null) aValue = "";
        if (bValue == null) bValue = "";
        
        // Convert to string for comparison
        aValue = String(aValue).toLowerCase();
        bValue = String(bValue).toLowerCase();
        
        if (sortDirection === "asc") {
          return aValue < bValue ? -1 : aValue > bValue ? 1 : 0;
        } else {
          return aValue > bValue ? -1 : aValue < bValue ? 1 : 0;
        }
      });
    }
    
    return data;
  }, [rowData, tableSearch, sortField, sortDirection]);

  // Paginate data
  const paginatedData = useMemo(() => {
    const startIndex = (currentPage - 1) * itemsPerPage;
    return filteredData.slice(startIndex, startIndex + itemsPerPage);
  }, [filteredData, currentPage, itemsPerPage]);

  const totalPages = Math.ceil(filteredData.length / itemsPerPage);

  const handleTableSearch = (e) => {
    setTableSearch(e.target.value);
    setCurrentPage(1); // Reset to first page when searching
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleSort = (field) => {
    if (sortField === field) {
      setSortDirection(sortDirection === "asc" ? "desc" : "asc");
    } else {
      setSortField(field);
      setSortDirection("asc");
    }
    setCurrentPage(1); // Reset to first page when sorting
  };

  const getContractEndDateStyle = (item) => {
    const expiresAfter = Number(item.contract_expires_after);
    if (expiresAfter < 30 && expiresAfter > 10) {
      return { color: "white", backgroundColor: "#E97451" };
    } else if (expiresAfter < 10 && expiresAfter > 0) {
      return { color: "white", backgroundColor: "#EE4B2B" };
    } else if (expiresAfter < 0) {
      return { color: "white", backgroundColor: "red" };
    } else if (item.contract_end_date == null || item.contract_end_date == "") {
      return { color: "white", backgroundColor: "red" };
    }
    return {};
  };

  const getAnnualLeave = (item) => {
    const annualLeave = item?.leave_data?.find(l => l.name?.includes("Annual"));
    return annualLeave?.remaining_days || "N/A";
  };

  const handleExport = () => {
    // Simple CSV export
    const headers = ["#", "Staff ID", "Staff Name", "Email", "Telephone", "Role", "Office", "Contract Start Date", "Contract End Date", "Annual Leave"];
    const csvContent = [
      headers.join(","),
      ...filteredData.map((item, index) => [
        index + 1,
        item.staff_id || "",
        item.staff_name || "",
        item.email || "",
        item.telephone || "",
        item.role_name || "",
        item.office_name || "",
        item.contract_start_date || "",
        item.contract_end_date || "",
        getAnnualLeave(item)
      ].join(","))
    ].join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", `LeaveBalances-${new Date().toISOString().split('T')[0]}.csv`);
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="page-wrapper">
      <div className="">
        <div className="-xl">
          <div className="card">
            <div className="card-header">
              <div className="row">
                <div className="col-md-8">
                  <h1>Leave Balances</h1>
                </div>
                <div className="col-md-4 text-end">
                  {rowData.length > 0 && (
                    <button
                      className="btn btn-success"
                      onClick={handleExport}
                    >
                      <FaFileExport style={{ color: "white" }} /> &nbsp; Export as Excel
                    </button>
                  )}
                </div>
              </div>
            </div>
            <div className="card-body">
              {is_processing && (
                <center>
                  <PulseLoader />
                </center>
              )}

              {!is_processing && (
                <>
                  <style>{`
                    .table-dark th {
                      font-size: 0.65rem !important;
                    }
                    .table-dark th span {
                      font-size: 0.65rem !important;
                    }
                    .table-dark th div {
                      font-size: 0.65rem !important;
                    }
                  `}</style>
                  {/* Search Bar */}
                  <div className="mb-4" style={{ width: '95%', margin: '0 auto' }}>
                    <div className="row">
                      <div className="col-md-6">
                        <div className="input-group">
                          <span className="input-group-text bg-primary text-white">
                            <FaSearch />
                          </span>
                          <Input
                            type="text"
                            className="form-control form-control-lg"
                            placeholder="Search by staff ID, name, email, role, office, or dates..."
                            value={tableSearch}
                            onChange={handleTableSearch}
                            style={{ borderLeft: 'none' }}
                          />
                        </div>
                      </div>
                      <div className="col-md-6 d-flex align-items-center">
                        <div className="text-muted">
                          <small>
                            {filteredData.length} staff member{filteredData.length !== 1 ? 's' : ''} found
                            {tableSearch && ` matching "${tableSearch}"`}
                          </small>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Data Table */}
                  <div className="table-responsive shadow-sm" style={{ width: '95%', margin: '0 auto', overflowX: 'auto' }}>
                    <table className="table table-striped table-hover mb-0" style={{ fontSize: '0.875rem', width: '100%', tableLayout: 'auto' }}>
                      <thead className="table-dark">
                        <tr style={{ height: '35px' }}>
                          <th style={{ width: '40px', padding: '6px', whiteSpace: 'nowrap' }}>#</th>
                          <th 
                            style={{ cursor: 'pointer', userSelect: 'none', padding: '6px', minWidth: '80px', maxWidth: '120px' }}
                            onClick={() => handleSort('staff_id')}
                            className="sortable-header"
                          >
                            <div className="d-flex align-items-center justify-content-between">
                              <span>Staff ID</span>
                              <span>
                                {sortField === 'staff_id' ? (
                                  sortDirection === 'asc' ? <FaSortUp /> : <FaSortDown />
                                ) : (
                                  <FaSort style={{ opacity: 0.3 }} />
                                )}
                              </span>
                            </div>
                          </th>
                          <th 
                            style={{ cursor: 'pointer', userSelect: 'none', padding: '6px', minWidth: '120px', maxWidth: '180px' }}
                            onClick={() => handleSort('staff_name')}
                            className="sortable-header"
                          >
                            <div className="d-flex align-items-center justify-content-between">
                              <span>Staff Name</span>
                              <span>
                                {sortField === 'staff_name' ? (
                                  sortDirection === 'asc' ? <FaSortUp /> : <FaSortDown />
                                ) : (
                                  <FaSort style={{ opacity: 0.3 }} />
                                )}
                              </span>
                            </div>
                          </th>
                          <th 
                            style={{ cursor: 'pointer', userSelect: 'none', padding: '6px', minWidth: '150px', maxWidth: '200px' }}
                            onClick={() => handleSort('email')}
                            className="sortable-header"
                          >
                            <div className="d-flex align-items-center justify-content-between">
                              <span>Email</span>
                              <span>
                                {sortField === 'email' ? (
                                  sortDirection === 'asc' ? <FaSortUp /> : <FaSortDown />
                                ) : (
                                  <FaSort style={{ opacity: 0.3 }} />
                                )}
                              </span>
                            </div>
                          </th>
                          <th 
                            style={{ cursor: 'pointer', userSelect: 'none', padding: '6px', minWidth: '100px', maxWidth: '130px' }}
                            onClick={() => handleSort('telephone')}
                            className="sortable-header"
                          >
                            <div className="d-flex align-items-center justify-content-between">
                              <span>Telephone</span>
                              <span>
                                {sortField === 'telephone' ? (
                                  sortDirection === 'asc' ? <FaSortUp /> : <FaSortDown />
                                ) : (
                                  <FaSort style={{ opacity: 0.3 }} />
                                )}
                              </span>
                            </div>
                          </th>
                          <th 
                            style={{ cursor: 'pointer', userSelect: 'none', padding: '6px', minWidth: '100px', maxWidth: '150px' }}
                            onClick={() => handleSort('role_name')}
                            className="sortable-header"
                          >
                            <div className="d-flex align-items-center justify-content-between">
                              <span>Role</span>
                              <span>
                                {sortField === 'role_name' ? (
                                  sortDirection === 'asc' ? <FaSortUp /> : <FaSortDown />
                                ) : (
                                  <FaSort style={{ opacity: 0.3 }} />
                                )}
                              </span>
                            </div>
                          </th>
                          <th 
                            style={{ cursor: 'pointer', userSelect: 'none', padding: '6px', minWidth: '100px', maxWidth: '150px' }}
                            onClick={() => handleSort('office_name')}
                            className="sortable-header"
                          >
                            <div className="d-flex align-items-center justify-content-between">
                              <span>Office</span>
                              <span>
                                {sortField === 'office_name' ? (
                                  sortDirection === 'asc' ? <FaSortUp /> : <FaSortDown />
                                ) : (
                                  <FaSort style={{ opacity: 0.3 }} />
                                )}
                              </span>
                            </div>
                          </th>
                          <th 
                            style={{ cursor: 'pointer', userSelect: 'none', padding: '6px', minWidth: '120px', maxWidth: '150px' }}
                            onClick={() => handleSort('contract_start_date')}
                            className="sortable-header"
                          >
                            <div className="d-flex align-items-center justify-content-between">
                              <span>Contract Start</span>
                              <span>
                                {sortField === 'contract_start_date' ? (
                                  sortDirection === 'asc' ? <FaSortUp /> : <FaSortDown />
                                ) : (
                                  <FaSort style={{ opacity: 0.3 }} />
                                )}
                              </span>
                            </div>
                          </th>
                          <th 
                            style={{ cursor: 'pointer', userSelect: 'none', padding: '6px', minWidth: '120px', maxWidth: '150px' }}
                            onClick={() => handleSort('contract_end_date')}
                            className="sortable-header"
                          >
                            <div className="d-flex align-items-center justify-content-between">
                              <span>Contract End</span>
                              <span>
                                {sortField === 'contract_end_date' ? (
                                  sortDirection === 'asc' ? <FaSortUp /> : <FaSortDown />
                                ) : (
                                  <FaSort style={{ opacity: 0.3 }} />
                                )}
                              </span>
                            </div>
                          </th>
                          <th 
                            style={{ cursor: 'pointer', userSelect: 'none', padding: '6px', minWidth: '80px', maxWidth: '120px' }}
                            onClick={() => handleSort('annual_leave')}
                            className="sortable-header"
                          >
                            <div className="d-flex align-items-center justify-content-between">
                              <span>Annual Leave</span>
                              <span>
                                {sortField === 'annual_leave' ? (
                                  sortDirection === 'asc' ? <FaSortUp /> : <FaSortDown />
                                ) : (
                                  <FaSort style={{ opacity: 0.3 }} />
                                )}
                              </span>
                            </div>
                          </th>
                          <th style={{ padding: '6px', width: '120px', whiteSpace: 'nowrap' }}>Details</th>
                        </tr>
                      </thead>
                      <tbody>
                        {paginatedData.length === 0 ? (
                          <tr>
                            <td colSpan="11" className="text-center text-muted py-4">
                              {tableSearch ? 'No staff members found matching your search' : 'No leave balances available'}
                            </td>
                          </tr>
                        ) : (
                          paginatedData.map((item, index) => (
                            <tr 
                              key={item.staff_id || index}
                              style={{ height: '35px', cursor: 'pointer' }}
                              className="table-row-hover"
                            >
                              <td className="text-muted fw-bold" style={{ padding: '6px', whiteSpace: 'nowrap' }}>
                                {(currentPage - 1) * itemsPerPage + index + 1}
                              </td>
                              <td style={{ padding: '6px', whiteSpace: 'nowrap' }}>
                                <small>{item?.staff_id || "N/A"}</small>
                              </td>
                              <td style={{ padding: '6px' }}>
                                <small className="text-truncate d-block" style={{ maxWidth: '180px' }} title={item?.staff_name}>
                                  {item?.staff_name || "N/A"}
                                </small>
                              </td>
                              <td style={{ padding: '6px' }}>
                                <small className="text-muted text-truncate d-block" style={{ maxWidth: '200px' }} title={item?.email}>
                                  {item?.email || "N/A"}
                                </small>
                              </td>
                              <td style={{ padding: '6px', whiteSpace: 'nowrap' }}>
                                <small className="text-muted">{item?.telephone || "N/A"}</small>
                              </td>
                              <td style={{ padding: '6px' }}>
                                <small className="text-truncate d-block" style={{ maxWidth: '150px' }} title={item?.role_name}>
                                  {item?.role_name || "N/A"}
                                </small>
                              </td>
                              <td style={{ padding: '6px' }}>
                                <small className="text-truncate d-block" style={{ maxWidth: '150px' }} title={item?.office_name}>
                                  {item?.office_name || "N/A"}
                                </small>
                              </td>
                              <td style={{ padding: '6px', whiteSpace: 'nowrap' }}>
                                <small className="text-muted">{item?.contract_start_date || "N/A"}</small>
                              </td>
                              <td style={{ padding: '6px', whiteSpace: 'nowrap', ...getContractEndDateStyle(item) }}>
                                <small>{item?.contract_end_date || "N/A"}</small>
                              </td>
                              <td style={{ padding: '6px', whiteSpace: 'nowrap', textAlign: 'center' }}>
                                <small><b>{getAnnualLeave(item)}</b></small>
                              </td>
                              <td style={{ padding: '6px', whiteSpace: 'nowrap' }}>
                                <Badge 
                                  className="btn-danger"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setSelected_staff(item);
                                    setshowModal(true);
                                  }}
                                  style={{ cursor: 'pointer', fontSize: '0.7rem', padding: '4px 8px' }}
                                >
                                  Leave Details
                                </Badge>
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </div>

                  {/* Pagination */}
                  {totalPages > 1 && (
                    <div className="d-flex justify-content-between align-items-center mt-4" style={{ width: '95%', margin: '0 auto' }}>
                      <div className="text-muted">
                        <small>
                          Showing {((currentPage - 1) * itemsPerPage) + 1} to {Math.min(currentPage * itemsPerPage, filteredData.length)} of {filteredData.length} staff members
                        </small>
                      </div>
                      
                      <nav aria-label="Leave balances pagination">
                        <ul className="pagination pagination-sm mb-0">
                          <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                            <button 
                              className="page-link" 
                              onClick={() => handlePageChange(currentPage - 1)}
                              disabled={currentPage === 1}
                            >
                              <span aria-hidden="true">&laquo;</span>
                            </button>
                          </li>
                          
                          {/* Show page numbers with smart pagination */}
                          {(() => {
                            const pages = [];
                            const maxVisiblePages = 5;
                            let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
                            let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);
                            
                            if (endPage - startPage + 1 < maxVisiblePages) {
                              startPage = Math.max(1, endPage - maxVisiblePages + 1);
                            }
                            
                            if (startPage > 1) {
                              pages.push(
                                <li key={1} className="page-item">
                                  <button className="page-link" onClick={() => handlePageChange(1)}>1</button>
                                </li>
                              );
                              if (startPage > 2) {
                                pages.push(<li key="ellipsis1" className="page-item disabled"><span className="page-link">...</span></li>);
                              }
                            }
                            
                            for (let i = startPage; i <= endPage; i++) {
                              pages.push(
                                <li key={i} className={`page-item ${currentPage === i ? 'active' : ''}`}>
                                  <button className="page-link" onClick={() => handlePageChange(i)}>{i}</button>
                                </li>
                              );
                            }
                            
                            if (endPage < totalPages) {
                              if (endPage < totalPages - 1) {
                                pages.push(<li key="ellipsis2" className="page-item disabled"><span className="page-link">...</span></li>);
                              }
                              pages.push(
                                <li key={totalPages} className="page-item">
                                  <button className="page-link" onClick={() => handlePageChange(totalPages)}>{totalPages}</button>
                                </li>
                              );
                            }
                            
                            return pages;
                          })()}
                          
                          <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                            <button 
                              className="page-link" 
                              onClick={() => handlePageChange(currentPage + 1)}
                              disabled={currentPage === totalPages}
                            >
                              <span aria-hidden="true">&raquo;</span>
                            </button>
                          </li>
                        </ul>
                      </nav>
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Modal for Leave Details */}
      <Modal
        isOpen={showModal}
        toggle={toggle}
        backdrop={true}
      >
        <ModalHeader toggle={toggle}>
          <div className="row">
            Leave Details for {selected_staff?.staff_name}
          </div>
        </ModalHeader>
        <ModalBody>
          <ul>
            {selected_staff?.leave_data?.map((l, index) => (
              <li key={index}>
                <h3> {l?.name} : {l?.remaining_days} </h3>
              </li>
            ))}
          </ul>
        </ModalBody>
      </Modal>
    </div>
  );
};

export default LeaveBalances;
